import styled from 'styled-components';

import { Input } from 'antd';


//Changed from: font-weight: 12px, line-height: 15px
export const StyledInput = styled(Input)`
	border: unset;
	border-radius: unset;
	
	border-bottom: 0.5px solid rgba(68, 68, 73, 0.5);
	
	padding: unset;
	
	font-weight: 500;
	font-size: 22px; 
	line-height: 25px;
	
	&:hover,
	&:focus {
		border-color: ${ props => props.theme.colors.fallow };
		box-shadow: unset;
	}
`;

export const ValidateMsg = styled.div<{ isError:boolean }>`
	font-weight: 500;
	font-size: 12px;
	line-height: 15px;
	
	color: ${({ isError, theme }: { isError: boolean, theme: any }) =>
		isError ? theme.colors.red : theme.colors.silver };
	
	margin-top: 5px;
	text-align: right;
`;
